export default __webpack_public_path__ + "static/media/Pistol_8.a70dc23d.png";